var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Card } from '@chakra-ui/react';
import React from 'react';
import { useFieldArray, useForm, useWatch } from 'react-hook-form';
import { ActionButtons, Form, RadioButtonField } from '../../shared';
import KeyFeatures from './KeyFeatures';
import PriceHeader from './PriceHeader';
import SmsCounter from './SmsCounter';
var PricingWidgetForm = function (_a) {
    var subscriptionPlans = _a.subscriptionPlans, smsPlan = _a.smsPlan, onSubmit = _a.onSubmit, isLoading = _a.isLoading, _b = _a.subscribeButtonProps, subscribeButtonProps = _b === void 0 ? {} : _b, _c = _a.subscribeButtonText, subscribeButtonText = _c === void 0 ? 'Subscribe to plan' : _c, props = __rest(_a, ["subscriptionPlans", "smsPlan", "onSubmit", "isLoading", "subscribeButtonProps", "subscribeButtonText"]);
    var defaultValues = {
        subscriptionId: subscriptionPlans[0].id,
        smsPackages: [],
    };
    var methods = useForm({ defaultValues: defaultValues });
    var selectedSubscriptionId = useWatch({ name: 'subscriptionId', control: methods.control });
    var selectedSubscription = subscriptionPlans.find(function (_a) {
        var id = _a.id;
        return id === selectedSubscriptionId;
    });
    var _d = useFieldArray({
        name: 'smsPackages',
        control: methods.control,
    }), fields = _d.fields, append = _d.append, remove = _d.remove;
    var summaryPrice = selectedSubscription.price + fields.length * (smsPlan === null || smsPlan === void 0 ? void 0 : smsPlan.price);
    var summarySms = selectedSubscription.sms + fields.length * (smsPlan === null || smsPlan === void 0 ? void 0 : smsPlan.sms);
    return (React.createElement(Card, __assign({ gap: 'xl', p: { base: 'lg', md: '2xl' }, variant: 'solid', w: { base: 'full', md: '30rem' } }, props),
        React.createElement(PriceHeader, { summaryPrice: summaryPrice }),
        React.createElement(Form, { childrenContainerProps: {
                gap: 'lg',
            }, formId: 'payment', methods: methods, onSubmit: function (data) { return onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(data); } },
            React.createElement(ActionButtons, { mb: 'xs', mt: '0', positiveButtonProps: __assign({ isLoading: isLoading, type: 'submit', width: 'full', variant: 'primary' }, subscribeButtonProps), positiveButtonText: subscribeButtonText }),
            React.createElement(RadioButtonField, { label: 'Monthly active users', name: 'subscriptionId', options: subscriptionPlans.map(function (_a) {
                    var activeUsers = _a.activeUsers, id = _a.id;
                    return ({
                        label: activeUsers,
                        value: id,
                    });
                }), onClick: function () { return remove(); } }),
            React.createElement(SmsCounter, { addPackage: function () { return append({ price: smsPlan.price }); }, isDisableMinus: !fields.length, minusPackage: function () { return remove(0); }, summarySms: summarySms }),
            React.createElement(KeyFeatures, null))));
};
export default PricingWidgetForm;
//# sourceMappingURL=PricingWidgetForm.js.map